import { render } from "./ConfirmationModal.vue?vue&type=template&id=68aced42&scoped=true"
import script from "./ConfirmationModal.vue?vue&type=script&lang=js"
export * from "./ConfirmationModal.vue?vue&type=script&lang=js"

import "./ConfirmationModal.vue?vue&type=style&index=0&id=68aced42&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-68aced42"

export default script